import React from "react";
import { motion } from "framer-motion";

const MotionSingle = ({
  children,
  className = "",
  offsetY = "100%",
  offsetX = 0,
  delay = 0,
  amount = 0.2,
  margin = "0px",
  stiffness = 75,
  damping = 15,
  restDelta = 0.01,
  animateInstantly = false,
}) => {
  const single = {
    hidden: {
      opacity: 0,
      y: offsetY,
      x: offsetX,
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      transition: {
        type: "spring",
        bounce: 0.2,
        delay,
        stiffness,
        damping,
        restDelta,
      },
    },
  };
  return (
    <motion.div
      initial="hidden"
      whileInView={!animateInstantly ? "visible" : ""}
      animate={animateInstantly ? "visible" : ""}
      variants={single}
      viewport={{ once: true, margin }}
      className={`${className}`}
    >
      {children}
    </motion.div>
  );
};

export default MotionSingle;
